<template>
  <div>
    <div class="select__flex_vf">
      <div>
        <select
          name=""
          v-model="sort"
          id=""
          @change="VerificationSummary()"
          class="form__select dashboard__filter"
        >
          <option value="all">All Requests</option>
          <option value="currentYear">This Year</option>
          <option value="currentMonth">This Month</option>
        </select>
      </div>
      <export-data-dropdown
        :csv-data="verificationRequests"
        :showOptions="showdataOptions"
        @toggleoptions="toggleDataOptions"
      />
    </div>

    <div class="dashboard__overview-top">
      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          {{ new Intl.NumberFormat().format(totalRequest) }}
        </p>
        <div class="dashboard__overview-booking-icon-wrap">
          <!-- <svgicon
            v-if="!summaryLoader"
            icon="listing_icon"
            class="dashboard__overview-booking-icon"
          ></svgicon> -->
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-booking-icon"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-if="summaryLoader"
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">Total Requests</p>
      </div>
      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          {{ new Intl.NumberFormat().format(completed) }}
        </p>
        <div class="dashboard__overview-listing-icon-wrap">
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-listing-icon"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-if="summaryLoader"
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">
          Completed Requests
        </p>
      </div>
      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          {{ new Intl.NumberFormat().format(pending) }}
        </p>
        <div class="dashboard__overview-earning-icon-wrap">
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-earning-icon"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-if="summaryLoader"
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">Pending Requests</p>
      </div>

      <div class="dashboard__overview-card">
        <p class="dashboard__overview-card-number">
          {{ new Intl.NumberFormat().format(incomplete) }}
        </p>
        <div class="dashboard__overview-active-icon-wrap">
          <svgicon
            v-if="!summaryLoader"
            icon="earnings_icon"
            class="dashboard__overview-active-icon"
            style="fill: #2e48da;stroke:transparent;"
          ></svgicon>
          <svgicon
            icon="spinner"
            v-else
            class="button__loader dashboard__overview-active-icon"
          ></svgicon>
        </div>
        <p class="dashboard__overview-card-text">Incomplete Request</p>
      </div>
    </div>

    <div>
      <select
        name=""
        v-model="status"
        id=""
        @change="getVerifications()"
        class="form__select dashboard__filter"
      >
        <option value="completed">Completed</option>
        <option value="incomplete">Incomplete</option>
        <option value="pending">Pending</option>
      </select>
    </div>

    <div
      class="dashboard__payment-history-wrap dashboard__overview-table"
      v-if="verificationRequests.length > 0"
    >
      <table class="dashboard__payment-history-table">
        <thead>
          <tr>
            <th class="dashboard__payment-history-table-heading"></th>
            <th class="dashboard__payment-history-table-heading">Host Name</th>
            <th class="dashboard__payment-history-table-heading">
              Tenant Name
            </th>

            <th class="dashboard__payment-history-table-heading">
              Date Requested
            </th>
            <th class="dashboard__payment-history-table-heading">
              Status
            </th>
            <th class="dashboard__payment-history-table-heading">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(singleRequest, index) in verificationRequests"
            :key="index"
            class="dashboard__table-row"
          >
            <td class="dashboard__payment-history-table-data ">
              {{ pageNumber(index + 1) }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ singleRequest.landlordName | capitalize }}
            </td>
            <td class="dashboard__payment-history-table-data">
              {{ singleRequest.firstName | capitalize }}
              {{ singleRequest.lastName | capitalize }}
            </td>

            <td class="dashboard__payment-history-table-data">
              {{ formatDate(singleRequest.createdAt) }}
            </td>

            <td class="dashboard__payment-history-table-data">
              <span
                class="dashboard__payment-history-table-status"
                :class="[
                  { pending: singleRequest.status == 'pending' },
                  { approve: singleRequest.status == 'completed' }
                ]"
                >{{ singleRequest.status | capitalize }}</span
              >
            </td>
            <td
              class="dashboard__payment-history-table-data dashboard__listing-table"
            >
              <b-dropdown
                id="dropdown-left"
                size="lg"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <svgicon
                    icon="table-menu"
                    class="dashboard__listing-table-menu"
                  ></svgicon>
                </template>
                <b-dropdown-item @click="handleViewVerify(singleRequest.id)"
                  >View</b-dropdown-item
                >
              </b-dropdown>
            </td>

            <!-- <td
              class="dashboard__payment-history-table-data dashboard__listing-table"
            >
              <span
                class="maintenance__table-action"
                @click="toggleView(singleRequest)"
                >View</span
              >
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dashboard__pagination">
      <b-pagination
        v-if="verificationRequests.length > 0"
        pills
        v-model="curPage"
        :total-rows="count"
        :per-page="pageSize"
        prev-text="Prev"
        next-text="Next"
        first-number
        last-number
        @change="handlePagination"
      ></b-pagination>
    </div>
    <div class="dashboard__empty" v-if="verificationRequests.length === 0">
      <div class="dashboard__booking-empty">
        <img
          src="../../assets/illustrations/noBookings.svg"
          alt=""
          class="img-fluid"
        />
      </div>
      <p class="dashboard__booking-empty-text">
        You have no verification request yet.
      </p>
    </div>

    <!-- <AppModal
      :show="showViewRequest"
      @onclosed="showViewRequest = false"
    >
      <p class="warning__title mb-5">Delete Extra Charge</p>

      <div class="form__group">
        <label for class="form__label">Reason for deleting</label>
        <textarea
          class="listing__textarea mb-0 full__width"
          v-model="deleteExtraChargeReason"
        ></textarea>
      </div>
      <div class="bedroom__preview-action">
        <button
          class="warning__cancel"
          @click="showViewRequest = false"
        >
          Cancel
        </button>
      </div>
    </AppModal> -->
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import exportDataDropdown from "../resuables/export-data.vue";

import {
  getVerificationRequests,
  getVerificationSummary
} from "../../../services/verify";
import { formatReadbleDate } from "../../utils";
export default {
  name: "settlement",
  components: {
    loader,

    exportDataDropdown
  },
  data: () => {
    return {
      verificationRequests: [],
      summaryLoader: false,
      loader: false,
      currentPage: 1,
      pageSize: 20,
      status: "pending",
      sort: "all",
      count: 0,
      pages: 0,
      pending: 0,
      completed: 0,
      incomplete: 0,
      totalRequest: 0,
      showViewRequest: false,
      id: null,
      paidLoader: false,
      showdataOptions: false
    };
  },
  watch: {
    $route() {
      this.getVerifications();
    }
  },
  methods: {
    handleViewVerify(id) {
      this.$router.push(`/verify-details/${id}?page=${this.currentPage}`);
    },
    pageNumber(index) {
      if (this.currentPage < 2) {
        return index;
      } else {
        return this.pageSize * (this.currentPage - 1) + index;
      }
    },
    toggleView(singleRequest) {
      this.selectedRequest = singleRequest;
      this.showViewRequest = !this.showViewRequest;
    },
    toggleDataOptions() {
      this.showdataOptions = !this.showdataOptions;
    },
    VerificationSummary() {
      this.summaryLoader = true;
      getVerificationSummary(this.sort)
        .then(res => {
          this.totalRequest = res.data.totalRequest;
          this.completed = res.data.completed;
          this.pending = res.data.pending;
          this.incomplete = res.data.incomplete;
          this.summaryLoader = false;
        })
        .catch(err => {
          this.summaryLoader = false;
          return err;
        });
    },
    async getVerifications() {
      this.loader = true;
      const data = await getVerificationRequests(
        this.status,
        this.getPages,
        this.pageSize
      );
      try {
        this.verificationRequests = data.data.allVerificationRequest;
        this.count = data.data.totalVerificationRequest;
        this.loader = false;
      } catch (err) {
        this.loader = false;
        return err;
      }
    },
    handlePagination(value) {
      if (value < 1) {
        this.pages = 1;
      }
      this.currentPage = value;
      this.pages = value;
      this.$router.push(`/verify?status=${this.status}&page=${this.pages}`);
    },
    formatDate(date) {
      return formatReadbleDate(date);
    }
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage: {
      get() {
        return this.$route.query.currentPage || 1;
      },
      set(value) {
        this.currentPage = value;
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    }
  },
  async mounted() {
    this.VerificationSummary();
    await this.getVerifications();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/verifyRequests.vue